module.exports = __webpack_public_path__ + "img/图片5.18189e74.png";